import { render, staticRenderFns } from "./motifDecesAction.vue?vue&type=template&id=4e3949b5"
import script from "./motifDecesAction.vue?vue&type=script&lang=js"
export * from "./motifDecesAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports